(() => {
  const money = (cents) => {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents) / 100); }
    catch { return `$${(Number(cents) / 100).toFixed(2)}`; }
  };

  const closeMegaMenus = (except) => {
    document.querySelectorAll('[data-spr-mega-item].is-open').forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector(':scope > button')?.setAttribute('aria-expanded', 'false');
    });
  };

  document.querySelectorAll('[data-spr-mega-item]').forEach((item) => {
    const trigger = item.querySelector(':scope > button');
    const open = () => {
      closeMegaMenus(item);
      item.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      item.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
    };
    item.addEventListener('pointerenter', open);
    item.addEventListener('pointerleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) close();
    });
    trigger?.addEventListener('click', (event) => {
      event.preventDefault();
      open();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMegaMenus();
    document.querySelectorAll('[data-spr-mobile-menu][open]').forEach((menu) => menu.removeAttribute('open'));
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-spr-header]')) closeMegaMenus();
    const quantityButton = event.target.closest('[data-spr-qty]');
    if (quantityButton) {
      const form = quantityButton.closest('form');
      const input = form?.querySelector('[data-spr-quantity]');
      if (!input) return;
      const current = Math.max(1, Number.parseInt(input.value || '1', 10));
      input.value = String(quantityButton.dataset.sprQty === 'plus' ? current + 1 : Math.max(1, current - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const cartQuantityButton = event.target.closest('[data-spr-cart-qty]');
    if (cartQuantityButton) {
      const control = cartQuantityButton.closest('[data-spr-cart-quantity]');
      const input = control?.querySelector('input[name="updates[]"]');
      if (!input) return;
      const current = Math.max(0, Number.parseInt(input.value || '0', 10));
      input.value = String(cartQuantityButton.dataset.sprCartQty === 'plus' ? current + 1 : Math.max(0, current - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const closeButton = event.target.closest('[data-spr-menu-close]');
    if (closeButton) {
      closeButton.closest('[data-spr-mobile-menu]')?.removeAttribute('open');
      return;
    }
    const menuLink = event.target.closest('.spr-mobile-drawer a');
    if (menuLink) menuLink.closest('[data-spr-mobile-menu]')?.removeAttribute('open');
  });

  document.querySelectorAll('[data-spr-sibling-colors]').forEach(async (root) => {
    const handle = root.dataset.productHandle || '';
    const mapUrl = root.dataset.colorMapUrl || '';
    if (!handle || !mapUrl) return;
    try {
      const response = await fetch(mapUrl, { credentials: 'same-origin' });
      if (!response.ok) return;
      const colorMap = await response.json();
      const colors = colorMap[handle];
      if (!Array.isArray(colors) || colors.length < 2) return;
      const legend = document.createElement('strong');
      legend.className = 'spr-sibling-colors__label';
      legend.textContent = 'Color';
      const list = document.createElement('div');
      list.className = 'spr-sibling-colors__values';
      colors.forEach((color) => {
        const link = document.createElement('a');
        link.href = `/products/${encodeURIComponent(color.handle)}`;
        link.textContent = color.label;
        if (color.handle === handle) {
          link.className = 'is-active';
          link.setAttribute('aria-current', 'page');
        }
        list.append(link);
      });
      root.replaceChildren(legend, list);
      root.hidden = false;
    } catch { /* Fail closed: official color links remain hidden if the sealed map cannot load. */ }
  });

  document.querySelectorAll('[data-spr-product]').forEach((root) => {
    const data = root.querySelector('[data-spr-variants]');
    const variantInput = root.querySelector('[data-spr-variant-id]');
    const price = root.querySelector('[data-spr-price]');
    const add = root.querySelector('[data-spr-add]');
    if (!data || !variantInput || !price || !add) return;
    let variants = [];
    try { variants = JSON.parse(data.textContent || '[]'); } catch { return; }
    const groups = [...root.querySelectorAll('[data-spr-option-index]')];
    const update = () => {
      const selected = groups.map((group) => group.querySelector('input:checked')?.value || '');
      const variant = variants.find((candidate) => selected.every((value, index) => candidate.options[index] === value)) || variants[0];
      if (!variant) return;
      variantInput.value = variant.id;
      price.innerHTML = `${money(variant.price)}${variant.compare_at_price > variant.price ? ` <s>${money(variant.compare_at_price)}</s>` : ''}`;
      add.disabled = !variant.available;
      add.textContent = variant.available ? `Add to bag — ${money(variant.price)}` : 'Sold out';
      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId) root.querySelector(`[data-spr-media-id="${mediaId}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    };
    groups.forEach((group) => group.addEventListener('change', update));
    const mediaTrack = root.querySelector('[data-spr-media-track]');
    const mediaProgress = root.querySelector('[data-spr-media-progress]');
    if (mediaTrack && mediaProgress) {
      const mediaCount = Math.max(1, mediaTrack.children.length);
      const updateMediaProgress = () => {
        const index = Math.min(mediaCount - 1, Math.max(0, Math.round(mediaTrack.scrollLeft / Math.max(1, mediaTrack.clientWidth))));
        mediaProgress.style.transform = `translateX(${index * 100}%)`;
      };
      mediaTrack.addEventListener('scroll', updateMediaProgress, { passive: true });
      updateMediaProgress();
    }
  });

  if (window.matchMedia('(max-width: 820px)').matches) {
    document.querySelectorAll('[data-spr-footer] details[open]').forEach((details) => details.removeAttribute('open'));
  }
})();
